"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withPopover;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactUtils = require("./react-utils");

var _popover = _interopRequireDefault(require("./popover"));

var _onClickOutside = _interopRequireDefault(require("./on-click-outside"));

var _keyboardCommands = require("./keyboard-commands");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var ClosablePopopver = (0, _keyboardCommands.keyboardCommands)((0, _onClickOutside["default"])(_popover["default"]), [{
  keys: 'escape',
  connectCommand: function connectCommand(props) {
    if (props.onRequestClose) {
      props.onRequestClose();
    }
  }
}]);
var currentInstanceID = 0;
/**
 * @typedef {Object} withPopoverOptions All of these are optional
 * @property {String} targetDirection 'left' | 'right' | 'up' | 'down', (default is 'down')
 * @property {String} anchorTargetAlign 'start' | 'end', (default is 'start')
 * @property {String} class to put on the button wrapping the anchor
 *
 * @param {Object} props
 * @param {React.Component} props.Anchor Anchor component to toggle open/close
 * @param {React.Component} props.Content Component that is rendered in popover
 * @param {withPopoverOptions?} props.options
 *
 * A higher order component for creating a popover for a given anchor with the given content
 * Usage: withPopover(anchor, content, options)
 *
 * The popover can be closed from the Content component via the requestPopoverClose method
 * passed to the Content component as a prop.
 *
 * Examples for targetDirection and anchorTargetAlign:
 * targetDirection = 'down', anchorTargetAlign = 'start'
 *  ------
 * |anchor|
 *  ------
 *  ---------
 * | popover |
 *  ---------
 *
 * targetDirection = 'down', anchorTargetAlign = 'end'
 *      ------
 *     |anchor|
 *      ------
 *   ---------
 *  | popover |
 *   ---------
 *
 * targetDirection = 'right', anchorTargetAlign = 'end'
 *          ---------
 *         | popover |
 *  ------ |         |
 * |anchor||         |
 *  ------  ---------
 *
 * If you wish to control the visibility of the popover from the outside provide the following props
 *
 * popoverOpen: boolean representing if the popover is open
 * onClickAnchor: Callback that will be passed the current open state of the popover.
 *
 * Legacy:
 * onClosePopover: method that closes the popover so that click away and escape keys can work
 */

function withPopover(Anchor, Content) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var WithPopover = /*#__PURE__*/function (_React$Component) {
    _inherits(WithPopover, _React$Component);

    var _super = _createSuper(WithPopover);

    function WithPopover(props) {
      var _this;

      _classCallCheck(this, WithPopover);

      _this = _super.call(this, props);
      var popoverOpen = props.popoverOpen; // unique key to identify this instance

      currentInstanceID += 1;
      _this.instanceId = currentInstanceID;
      _this.onClickAnchor = _this.onClickAnchor.bind(_assertThisInitialized(_this));

      if (_this.onClosePopover) {
        _this.onClosePopover = _this.onClosePopover.bind(_assertThisInitialized(_this));
      }

      _this.state = {
        popoverOpen: popoverOpen || false
      };
      return _this;
    }

    _createClass(WithPopover, [{
      key: "onClickAnchor",
      value: function onClickAnchor() {
        var _this$props = this.props,
            onClosePopover = _this$props.onClosePopover,
            onClickAnchor = _this$props.onClickAnchor;
        var popoverOpen = this.state.popoverOpen;
        /**
         * When the component is controlled (popoverOpen !== undefined)
         * we want to fire this callback any time the anchor is clicked.
         */

        if (onClickAnchor && popoverOpen !== undefined) {
          onClickAnchor(popoverOpen);
          return;
        }
        /**
         * Legacy functionality, onClosePopover() was only called when
         * popoverOpen is true. There was previously no way to re-open
         * a closed popover.
         */
        // only toggle on state if we are not controlling it from props


        if (onClosePopover && popoverOpen) {
          onClosePopover();
          return;
        }

        this.setState({
          popoverOpen: !popoverOpen
        });
      }
    }, {
      key: "onClosePopover",
      value: function onClosePopover() {
        var onClosePopover = this.props.onClosePopover; // only toggle on state if we are not controlling it from props

        if (onClosePopover) {
          onClosePopover();
        }

        this.setState({
          popoverOpen: false
        });
      }
    }, {
      key: "renderPopover",
      value: function renderPopover(instanceClass) {
        var popoverOpen = this.state.popoverOpen;
        var clickOutsideToClose = this.props.clickOutsideToClose;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "Popover-position"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "Popover-position-safari-fix"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "Popover-arrow"
        }), /*#__PURE__*/_react["default"].createElement(ClosablePopopver, {
          open: popoverOpen,
          onRequestClose: clickOutsideToClose ? this.onClosePopover : null // exclude the target itself from clickoutside so the popover's
          //  visibility is toggled
          ,
          outsideClickIgnoreClass: instanceClass
        }, /*#__PURE__*/_react["default"].createElement(Content, _extends({}, this.props, {
          requestPopoverClose: this.onClosePopover
        })))));
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        // adjust popover position based on targetDirection and anchorTargetAlign
        // set the proper class name. Actual adjustment happens in css.
        var positionClass = options ? "".concat(options.targetDirection || 'down', " ").concat(options.anchorTargetAlign || 'start') : 'down start'; // use a unique instance class so that every anchor is tracked separately
        // and clicking from one anchor to another closes the popout properly

        var instanceClass = "Popover-instance-".concat(this.instanceId);
        var className = this.props.className;
        var popoverOpen = this.state.popoverOpen;
        var topLevelClasses = (0, _bind["default"])({
          header: options.hasHeader
        }, ['Popover-container', positionClass, className]);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: topLevelClasses
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: (0, _bind["default"])({
            open: popoverOpen
          }, ['Popover-anchor', instanceClass, options.anchorClass]),
          onClick: this.onClickAnchor
        }, /*#__PURE__*/_react["default"].createElement(Anchor, this.props)), (0, _reactUtils.includeWhen)(popoverOpen, function () {
          return _this2.renderPopover(instanceClass);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref) {
        var popoverOpen = _ref.popoverOpen;

        // override state if externally controlled
        if (popoverOpen !== undefined) {
          return {
            popoverOpen: popoverOpen
          };
        } // keep internal state if not externally controlled


        return null;
      }
    }]);

    return WithPopover;
  }(_react["default"].Component);

  WithPopover.propTypes = {
    className: _propTypes["default"].string,
    clickOutsideToClose: _propTypes["default"].bool,
    onClickAnchor: _propTypes["default"].func,
    onClosePopover: _propTypes["default"].func,
    popoverOpen: _propTypes["default"].bool
  };
  WithPopover.defaultProps = {
    className: '',
    clickOutsideToClose: true,
    onClickAnchor: undefined,
    onClosePopover: undefined,
    popoverOpen: undefined
  };
  WithPopover.displayName = "WithPopover(".concat(getDisplayName(Anchor), ")");
  return WithPopover;
}